/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { useLocalization } from './LocalizationProvider';
import { BCP47LanguageTag as BCP47LanguageTagSrc } from './types';
import { i18n, init } from './setup';
import { SupportedLocaleDTO } from '@coop/atacama-codegen';
import { LanguageSelector } from './LanguageSelector';

export type BCP47LanguageTag = BCP47LanguageTagSrc;
export { useLocalization, i18n, LanguageSelector, init };

export const localeToLanguageTag: Record<
  SupportedLocaleDTO,
  BCP47LanguageTag
> = {
  [SupportedLocaleDTO.EnUS]: 'en-US',
  [SupportedLocaleDTO.EsUS]: 'es-US'
};

export const localeToLanguage: Record<SupportedLocaleDTO, string> = {
  [SupportedLocaleDTO.EnUS]: 'English',
  [SupportedLocaleDTO.EsUS]: 'Español'
};
